import { render } from "./DeliveredOrders.vue?vue&type=template&id=62a2e9ff&scoped=true"
import script from "./DeliveredOrders.vue?vue&type=script&lang=js"
export * from "./DeliveredOrders.vue?vue&type=script&lang=js"

import "./DeliveredOrders.vue?vue&type=style&index=0&id=62a2e9ff&scoped=true&lang=css"

import exportComponent from "../../../../../../../../../../Users/karimdmai2026/Eurekali-Souverainete/eurekali-b2c/eurekalifront/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-62a2e9ff"]])

export default __exports__